var React = require('react');

function SuccessStoryVideoPlayIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.700195 3.38562C0.700195 1.03509 3.28069 -0.402389 5.27926 0.834823L17.5797 8.44937C19.4743 9.62221 19.4743 12.3781 17.5797 13.551L5.27926 21.1655C3.28069 22.4027 0.700195 20.9652 0.700195 18.6147V3.38562Z","fill":"#777E91"}));
}

SuccessStoryVideoPlayIcon.defaultProps = {"width":"19","height":"22","viewBox":"0 0 19 22","fill":"none"};

module.exports = SuccessStoryVideoPlayIcon;

SuccessStoryVideoPlayIcon.default = SuccessStoryVideoPlayIcon;
